import React from 'react';

const { Provider, Consumer } = React.createContext({
    primary: '#ef018d',
    secondary: '#f5f5f5',
    third: '#d5d5d5',
});

export { Provider as Theme, Consumer };
